module.exports = __webpack_public_path__ + "img/student-1.e2bdb51b.jpg";